/**
 * Sticker constructor
 * @constructor shared.stage.components.Sticker
 */
 fx.ns("shared.stage.components", class Sticker extends shared.stage.base.MediaComponent{
    
	constructor(component, model, baseSVG, manual, commands)
	{
		super(component, model, baseSVG, commands, model.stickers, manual );

		this.avoidlostBorder = true;

        this.selectable = !fx.browser.isMobile || fx.browser.isTablet;
	}

	
	get minComponentSize()
    {
        return  {
            height : 5,
            width : 5
        }
	}

	get editable(){
        return this._editable && (this.movable || this.resizable);
    }

	set editable(val){
        this._editable = val;

        this.toggleClass("not-editable", !val);
    }
    
	
	updateCommands()
	{
		super.updateCommands();

        this.command("inverth", "visible" , this.flippable);

		this.command("remove", "visible" , this.removable);
	}

	
	create()
	{
		super.create();

		this.image = new fx.components.Image();
		this.image.attr("draggable", false);


		this.addChild(this.image, {width : "100%", height : "100%", top : 0, left : 0});
	}
	
	updateMedia(content) 
    {
		super.updateMedia( content )
		
		if (content && this._media instanceof models.EmptyMedia) // so sticker was deleted
		{
			if (fx.get("app") != "screenshot")
				this.delay(this._deleteNotUsed); //  we add a delay in order to not create loop problem on load stage
			else
				this.data.event("media-loaded"); // TO CHECK
		}

		this.showActions = this.editable;
	}

	_deleteNotUsed()
	{
		this.data.delete(true);
	}

	onDataUpdated(action)
    {
		super.onDataUpdated(action);

		if (action.type == "init")
		{
			this.updateMedia(this.component.content);
			this.attr("data-id", this.data.id);
		}

		if (action.impacts("effectName"))
			this.onDisplayUpdated();
	}

	onDisplayUpdated()
	{
		super.onDisplayUpdated();

		let scale = [1,1];
		let translate = [0,0];

		if (this.component.effectName.indexOf("h") > -1)
		{
			scale[0] = -1;
			translate[0] = this.width;
		}

		if (this.component.effectName.indexOf("v") > -1)
		{
			scale[1] = -1;
			translate[1] = this.height;
		}

		this.image.css("transform", "translate(" + translate[0] + "px, " + translate[1] + "px) scale(" + scale[0] + "," + scale[1] + ")");
	}




	onMirrorH()
	{
		this.data.effectName = (this.data.effectName.indexOf("h") > -1) ? this.data.effectName.replace("h", "") : ( this.data.effectName + "h");
	}

	onMirrorV()
	{
		this.data.effectName = (this.data.effectName.indexOf("v") > -1) ? this.data.effectName.replace("v", "") : ( this.data.effectName + "v");
	}
	

});